import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import { Typography } from '@/components/novoville';
import { translate } from '../../services/TranslationService';
import { goTo } from '../../shared/actions';
import { MODULE_CTA_METADATA, shownModulesEnabledFn } from './constants';

const QuickActionsCard = ({
  basicColor,
  title,
  subTitle,
  icon,
  cardAction,
}) => {
  return (
    <div className="flex h-full flex-col rounded-[16px] bg-gray-50 items-center justify-center p-[24px]">
      <div
        className={`bg-${basicColor} rounded-full w-[40px] h-[40px] flex items-center justify-center`}
      >
        {icon}
      </div>

      <Typography variant="bold_24" className="pb-[4px] pt-[16px]">
        {title}
      </Typography>
      <Typography
        variant="regular_16"
        className="pb-[24px] text-center text-gray-700 flex-1"
      >
        {subTitle}
      </Typography>
      {cardAction}
    </div>
  );
};

const QuickActionsSection = ({
  hasVerifiedEmail,
  hasVerifiedPhoneNumber,
  goTo,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(null);

  const handleVerificationModalSkip = (gotoPage) => {
    if (hasVerifiedEmail && hasVerifiedPhoneNumber) {
      goTo(gotoPage);
      return setIsModalOpen(null);
    }
  };

  const { modules } = useSelector((state) => ({
    modules: state.otherReducer?.modules,
  }));

  const shownModulesEnabled = shownModulesEnabledFn(modules);

  const moduleMetadataMap = MODULE_CTA_METADATA({
    setIsModalOpen,
    goTo,
    isModalOpen,
    handleVerificationModalSkip,
  });

  return (
    <div className="flex">
      <div className="flex flex-col bg-white w-full sm:p-[32px] p-[24px] sm:rounded-[16px] rounded-0 gap-[24px]">
        <div className="flex sm:flex-row md:flex-row flex-col items-center justify-between ">
          <Typography variant="bold_20" className="text-center text-gray-900">
            {translate('Simplifying City Living')}
          </Typography>
        </div>
        <div
          className={`grid gap-4 grid-cols-1 sm:grid-cols-1  ${
            shownModulesEnabled.length % 2 === 1
              ? 'lg:grid-cols-3'
              : 'lg:grid-cols-2'
          }`}
        >
          {shownModulesEnabled.map((moduleName) => {
            const moduleMetadata = moduleMetadataMap[moduleName];

            return (
              <QuickActionsCard
                key={module.name}
                basicColor={moduleMetadata.basicColor}
                title={moduleMetadata.title}
                subTitle={moduleMetadata.subTitle}
                icon={moduleMetadata.icon}
                cardAction={moduleMetadata.cardAction}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

var mapStateToProps = (state) => {
  return {
    solved: state.homeReducer.no_completed,
    pending: state.homeReducer.no_pending,
    hasVerifiedEmail: state.profileReducer.hasVerifiedEmail,
    hasVerifiedPhoneNumber: state.profileReducer.hasVerifiedPhoneNumber,
  };
};

var mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      goTo,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickActionsSection);
